"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var UsageReportModel = /** @class */ (function () {
    function UsageReportModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/reports/usage",
            UPDATE: APPURL + "/api/v1/reports/usage",
            CREATE: APPURL + "/api/v1/reports/usage",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.get = this.get.bind(this);
        this.getStudentUsageSessionTypes =
            this.getStudentUsageSessionTypes.bind(this);
    }
    UsageReportModel.prototype.extract = function (result) {
        return result.data;
    };
    UsageReportModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    UsageReportModel.prototype.get = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResults);
    };
    UsageReportModel.prototype.getStudentUsageSessionTypes = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "/session-types?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResults);
    };
    return UsageReportModel;
}());
UsageReportModel.$inject = ["$http", "APPURL"];
exports.default = UsageReportModel;
